export default {
  data() {
    return {
      storeNamespace: "",
    };
  },
  computed: {
    getStatus() {
      return this.$store.state[this.storeNamespace].status;
    },
    getStatusByParameter() {
      return (payload) => this.$store.state[this.storeNamespace][payload];
    },
    getLoadingStatus() {
      return this.$store.state[this.storeNamespace].status === "loading";
    },
  },
};
